import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';
import {
	setCommunes as setCommunesReducer,
} from './reducer';

export const reserveSlice = createSlice({
  name: 'models',
  initialState: initialState,
  reducers: {
    setCommunes: setCommunesReducer,
  },
});

export const { setCommunes } = reserveSlice.actions;
/*
export const getInputData = (object, input) => {
  return (state) => state.checkin2[object].form[input];
};
*/

export const getCommunes = (state) => state.models.communes;
export const getMonths = (state) => state.models.months;
export const getYears = (state) => state.models.years;

export default reserveSlice.reducer;